/**************************************************************************************************/
/*   File: /src/app/shared/models/plan.type.ts                                                    */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 12th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The plan type managed from newplan
 */
export class PlanType {
    /**
     * The value
     */
    value: string;
    /**
     * The name
     */
    name: string;
}